<template>
  <div class="pdf-wrap">
    <pdf :src="pdfSrc" :page="currentPage" @num-pages="pageCount = $event" @loaded="onLoaded" @error="onError" style="height: calc(100% - 35px); overflow-y: scroll"></pdf>
    <div class="arrow">
      <div @click="changePdfPage(0)" class="turn" :class="{ grey: currentPage == 1 }">上一页</div>
      <div>{{ currentPage }} / {{ pageCount }}</div>
      <div @click="changePdfPage(1)" class="turn" :class="{ grey: currentPage == pageCount }">下一页</div>
    </div>
  </div>
</template>
<script>
import pdf from "vue-pdf";
export default {
  name: "Pdf",
  props: {
    pdfSrc: {
      type: String,
      default: "",
      description: "需要展示的PDF地址",
    },
    title: {
      type: String,
      default: "",
    },
  },
  components: { pdf },
  data() {
    return {
      currentPage: 1, // 当前展示的PDF页码
      pageCount: 0, // PDF文件总页码
    };
  },
  methods: {
    // 改变PDF页码,val传过来区分上一页下一页的值,0上一页,1下一页
    changePdfPage(val) {
      if (val === 0 && this.currentPage > 1) {
        this.currentPage--;
      }
      if (val === 1 && this.currentPage < this.pageCount) {
        this.currentPage++;
      }
    },
    // pdf加载时
    onLoaded() {
      this.currentPage = 1; // 加载的时候先加载第一页
    },
    onError(error) {
      console.log("Error loading PDF:", error);
    },
  },
};
</script>
<style lang="scss" scoped>
.pdf-wrap {
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 8px 10px;
  flex: 1;
  overflow: hidden;
  overflow-y: scroll;
  background: #e7e8eb;
  .arrow {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #666666;
    padding-top: 8px;
    font-weight: 600;
    .turn {
      border: 1px solid #666666;
      border-radius: 4px;
      padding: 2px 4px;
      cursor: pointer;
      margin: 0 8px;
    }
    .grey {
      color: #ccc;
      border: 1px solid #ccc;
      cursor: not-allowed;
    }
  }
}
</style>
